import random from 'lodash/random';

const generatePOOrderNumber = () => {
  const epochTime = Date.now().toString().slice(0, 10);
  const randomNumber = random(0, 9);
  return epochTime + randomNumber;
};

export default generatePOOrderNumber;
